import type { NuxtUiTheme } from '../types/nuxt-ui-theme';
import {
    controlDescriptionStyles,
    controlLabelStyles,
    checkableControlDisabledStyles,
    checkableControlRootStateStyles
} from '../shared-styles';

export default {
    slots: {
        root: 'mt-6',
        label: 'text-(--text-light)'
    },
    variants: {
        color: {
            neumorphic: {
                root:
                    'relative flex items-center font-(family-name:--primary-font) ' +
                    checkableControlRootStateStyles +
                    ' has-data-disabled:cursor-not-allowed ' +
                    '[&:has([data-disabled])_[data-slot=base]]:bg-(image:--input-neumorphic-disabled-bg)! ' +
                    '[&:has([data-disabled])_[data-slot=base]]:border-(--input-neumorphic-disabled-border)! ' +
                    '[&:has([data-disabled])_[data-slot=base]]:shadow-(--input-neumorphic-disabled-shadow)! ' +
                    '[&:has([data-disabled])_[data-slot=label]]:text-(--text-muted)! ' +
                    '[&:has([data-disabled])_[data-slot=thumb]]:bg-(image:--input-neumorphic-disabled-bg)! ' +
                    '[&:has([data-disabled])_[data-slot=thumb]]:border-(--input-neumorphic-disabled-border)! ' +
                    '[&:has([data-disabled])_[data-slot=thumb]]:shadow-none!',
                container: 'flex items-center shrink-0 h-6.5',
                base:
                    'w-12! p-0.75! bg-(image:--control-bg-neumorphic)! border-[0.063rem]! border-solid! ' +
                    'border-(--control-border-neumorphic)! shadow-(--panel-shadow-soft-inset) ' +
                    '[transition:border-color_0.3s_cubic-bezier(0.25,0.8,0.25,1),box-shadow_0.3s_cubic-bezier(0.25,0.8,0.25,1),background_0.3s_cubic-bezier(0.25,0.8,0.25,1)]! ' +
                    'will-change-[border-color,box-shadow,background] ' +
                    'hover:border-(--control-border-neumorphic-hover)! ' +
                    'hover:bg-(image:--control-bg-neumorphic-hover)! hover:shadow-(--input-neumorphic-hover-shadow) ' +
                    'focus-visible:outline-none! focus-visible:border-(--input-neumorphic-focus-border)! ' +
                    'focus-visible:shadow-(--input-neumorphic-focus-shadow) ' +
                    'data-[state=checked]:bg-(image:--button-dark-surface)! ' +
                    'data-[state=checked]:border-(--input-neumorphic-checked-border)! ' +
                    'data-[state=checked]:shadow-(--input-neumorphic-checked-shadow) ' +
                    'data-[state=checked]:hover:shadow-(--input-neumorphic-checked-hover-shadow) ' +
                    checkableControlDisabledStyles,
                thumb:
                    'w-5! h-5! bg-(image:--input-neumorphic-thumb-surface)! border-[0.063rem] border-solid ' +
                    'border-(--input-neumorphic-disabled-border) shadow-(--input-neumorphic-thumb-shadow)! ' +
                    '[transition:transform_0.3s_cubic-bezier(0.25,0.8,0.25,1),translate_0.3s_cubic-bezier(0.25,0.8,0.25,1),box-shadow_0.3s_cubic-bezier(0.25,0.8,0.25,1),background_0.3s_cubic-bezier(0.25,0.8,0.25,1),border-color_0.3s_cubic-bezier(0.25,0.8,0.25,1)]! ' +
                    'data-[state=checked]:translate-x-5! data-[state=checked]:translate-y-0! ' +
                    'data-[state=checked]:bg-(image:--input-neumorphic-thumb-active-surface)! ' +
                    'data-[state=checked]:border-(--white-alpha-30) ' +
                    'data-[state=checked]:shadow-(--input-neumorphic-thumb-active-shadow)! ' +
                    'data-[state=unchecked]:translate-x-0! data-[state=unchecked]:translate-y-0! ' +
                    'rtl:data-[state=checked]:-translate-x-5!',
                icon: 'text-(--text-light)!',
                wrapper: 'ml-2.5',
                label: controlLabelStyles,
                description: controlDescriptionStyles
            }
        }
    }
} satisfies NuxtUiTheme['switch'];
